type TextSuggestionsExperimentStateParams = {
  isTextSuggestionsFlowOptionEnabled: boolean
}

type TextSuggestionsExperimentState = {
  isInExperiment: boolean
  isTextSuggestionsEnabled: boolean
}

export function getTextSuggestionsExperimentState({
  isTextSuggestionsFlowOptionEnabled,
}: TextSuggestionsExperimentStateParams): TextSuggestionsExperimentState {
  if (!isTextSuggestionsFlowOptionEnabled) {
    return {
      isInExperiment: false,
      isTextSuggestionsEnabled: false,
    }
  }

  return {
    isInExperiment: false,
    isTextSuggestionsEnabled: true,
  }
}
